import { h } from 'preact';

const ChevronLeft = (props) => {
	return (
		<svg width="13" height="25" viewBox="0 0 13 25" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M12.2946 23.22C12.5676 23.5125 12.5676 23.988 12.2946 24.2805C12.0201 24.573 11.5776 24.573 11.3031 24.2805L0.70414 13.032C0.43114 12.738 0.43114 12.2625 0.70414 11.97L11.3031 0.719977C11.4396 0.572977 11.6196 0.500977 11.7981 0.500977C11.9781 0.500977 12.1566 0.572977 12.2946 0.719977C12.5676 1.01248 12.5676 1.48798 12.2946 1.78198L2.17864 12.501L12.2946 23.22Z" />
		</svg>
	);
};

export default ChevronLeft;